import React from 'react';
import { Link, useParams } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import HtmlBody from '../../components/HtmlBody';
import jobs from '../../data/marketing/jobs.json';

export default function JobDetailPage() {
  const { slug } = useParams();
  const job = jobs.find((item) => item.slug === slug && !item.isDraft);

  if (!job) {
    return (
      <MarketingShell title="Role not found">
        <Link to="/careers" className="text-sm font-medium text-gray-900">
          Back to careers
        </Link>
      </MarketingShell>
    );
  }

  return (
    <MarketingShell>
      <article className="rounded-xl border border-gray-100 bg-white p-6">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Careers</p>
        <h1 className="mt-2 text-xl font-semibold tracking-tight text-gray-900">{job.name}</h1>
        <p className="mt-2 text-sm text-gray-500">
          {[job.location, job.employmentBasis].filter(Boolean).join(' · ')}
        </p>
        <div className="mt-6">
          <HtmlBody html={job.body} />
        </div>
        <a
          href={`mailto:hello@getupgraded.ai?subject=${encodeURIComponent(`Application: ${job.name}`)}`}
          className="mt-8 inline-flex items-center rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 transition-colors"
        >
          Apply
        </a>
      </article>
    </MarketingShell>
  );
}
